// Collects every article body and derives reading time from its word count.
import seo from "./seo";
import socialMedia from "./social-media";
import paidMedia from "./paid-media";
import ai from "./ai";
import web from "./web";
import branding from "./branding";
import localSeo from "./local-seo";
import whatsappMarketing from "./whatsapp-marketing";
import cro from "./cro";
import healthcareMarketing from "./healthcare-marketing";
import ecommerceRetention from "./ecommerce-retention";
import marketingAnalytics from "./marketing-analytics";

const raw = {
  seo,
  "social-media": socialMedia,
  "paid-media": paidMedia,
  ai,
  web,
  branding,
  "local-seo": localSeo,
  "whatsapp-marketing": whatsappMarketing,
  cro,
  "healthcare-marketing": healthcareMarketing,
  "ecommerce-retention": ecommerceRetention,
  "marketing-analytics": marketingAnalytics,
};

/** Counts words in every string found inside a post (paragraphs, list items, callouts). */
function countWords(value) {
  if (typeof value === "string") return value.split(/\s+/).filter(Boolean).length;
  if (Array.isArray(value)) return value.reduce((sum, v) => sum + countWords(v), 0);
  if (value && typeof value === "object") return Object.values(value).reduce((sum, v) => sum + countWords(v), 0);
  return 0;
}

export const postDetails = Object.fromEntries(
  Object.entries(raw).map(([slug, post]) => {
    const words = countWords(post);
    return [slug, { ...post, words, readTime: `${Math.max(1, Math.round(words / 200))} min read` }];
  })
);
